import ActivateUserAccountForm from './ActivateUserAccountForm';

export default ActivateUserAccountForm;
